export default __webpack_public_path__ + "static/media/tools.d8bb3753.jpg";